import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import {
	EditGameDeveloperContext,
	IEditGameDeveloperContext,
} from '../editDeveloperModalContext/editDeveloperModalState/editDeveloperModalContext';
import {
	GameDevelopersContext,
	IGameDevelopersContext,
} from 'modules/Entertainment/Games/GameDevelopers/gameDevelopersState/gameDevelopersContext';
import { updateGameDeveloper } from 'backend/games';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<IEditGameDeveloperContext>(EditGameDeveloperContext);
	const { changeTypeOfModalWindow: changeTypeOfGameDevelopersModalWindow, refetchDevelopers } =
		useContext<IGameDevelopersContext>(GameDevelopersContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleReset = useCallback(() => {
		changeTypeOfModalWindow(null);
		changeTypeOfGameDevelopersModalWindow(null);
	}, []);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateGameDeveloper(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		refetchDevelopers(true);
		changeTypeOfModalWindow(null);
		changeTypeOfGameDevelopersModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleReset}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleUpdateData}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
